// extracted by mini-css-extract-plugin
module.exports = {"reportTableWrapper":"AuditDetails_reportTableWrapper__1RswD"};